import { Map } from 'immutable';
import { MATCH_EXTRAS } from '../constants';

export function getExtra(match: Map<string, any>, code: string): Map<string, any> {
    return match?.getIn(['extras', code]);
}

export function getExtraValueAsString(extra: Map<string, any>): string {
    return extra?.get('parameters')?.first();
}

export function getExtraValueAsBoolean(extra: Map<string, any>): boolean {
    return getExtraValueAsString(extra) === '1';
}

export function isRainDelayExtra(match: Map<string, any>): boolean {
    const rainDelayExtra = getExtra(match, MATCH_EXTRAS.rainDelay);
    if (!rainDelayExtra) {
        return false;
    }
    return getExtraValueAsBoolean(rainDelayExtra);
}

export function isNoAdvantageExtra(match: Map<string, any>): boolean {
    const noAdvantageExtra = getExtra(match, MATCH_EXTRAS.noAdvantage);
    if (!noAdvantageExtra) {
        return false;
    }
    return getExtraValueAsBoolean(noAdvantageExtra);
}

export function getScoreboardType(match: Map<string, any>): string {
    const scoreboardTypeExtra = getExtra(match, MATCH_EXTRAS.scoreboardType);
    if (!scoreboardTypeExtra) {
        return null;
    }
    return getExtraValueAsString(scoreboardTypeExtra);
}
